module.exports = __webpack_public_path__ + "img/service-and-shop-filter-honda.f6917ea9.jpg";